import { GATED_VIDEO_SLICE_KEY } from './slice';
/**
 * Selects the unlocked video ids from the gated video state.
 */
export function unlockedVideoIdsSelector(state) {
    // CS-4308: This is a temporary workaround to prevent the app from crashing
    return state[GATED_VIDEO_SLICE_KEY]?.unlockedVideoIds ?? {};
}
/**
 * Selects the setUnlockedVideoIds action from the gated video state.
 */
export function gatedVideoActionsSelector(state) {
    // CS-4308: This is a temporary workaround to prevent the app from crashing
    return state[GATED_VIDEO_SLICE_KEY]?.actions;
}
/**
 * Selects the checked video ids map from the gated video state
 */
export function checkedVideoIdsSelector(state) {
    return state[GATED_VIDEO_SLICE_KEY]?.checkedVideoIds;
}
